<template>
  <div class="factory-visual" :class="variant">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FactoryVisual',
  props: {
    variant: { type: String, default: '' }
  }
};
</script>
